import AlertMessage from '../../OC/oc-alert-message';

// eslint-disable-next-line react/prop-types
export default ({ message, title = 'Note', type = 'info' }) => (
  <AlertMessage
    alertIcon={true}
    dismissable={false}
    message={`<b>${title}:</b> ${message}`}
    style={{ marginBottom: '0px' }}
    textSize="13px"
    type={type}
  />
);
